<script >import { onMount } from 'svelte';
import { getTroisInternalContext } from './context';
import GetChild from './GetChild.svelte';
export let onClick = undefined;
export let onMouseMove = undefined;
const three = getTroisInternalContext();
let child;
onMount(() => {
    if (onClick)
        three.onObjectClick(child, onClick);
    if (onMouseMove)
        three.onObjectMouseMove(child, onMouseMove);
});
</script>

<GetChild bind:child>
  <slot />
</GetChild>
